import { Composition } from 'remotion';
import {
  ProductReviewTemplate,
} from '../XHSTemplates';

export const XHSTemplatesCompositions = () => (
  <>
    {/* 🎬 小红书完整模板（2026-03-11）*/}
    
    {/* 1️⃣ 好物分享模板（15秒）*/}
    <Composition
      id="XHS-ProductReview-Template"
      component={ProductReviewTemplate}
      durationInFrames={450} // 15秒 * 30fps
      fps={30}
      width={1080}
      height={1920}
    />
  </>
);
